export const featureFlags = {
  /**
   * Global kill-switch for the maintenance/announcement banner.
   *
   * We keep the banner implementation (remote config, chain gating, etc.)
   * but can disable rendering everywhere from one place.
   */
  enableMaintenanceBanner: false,
} as const;
